const errors = [
  'Оффер, который не читают',
  'Медленная загрузка страницы',
  'Форма с лишними полями',
  'Отсутствие социальных доказательств',
  'Нет мобильной адаптации',
  'Слабый призыв к действию',
  'Непонятная навигация',
  'Нет ответа на возражения',
  'Нет структуры «боль → решение»',
  'Ошибки в микроконверсиях',
];

export default function AuditLeadMagnet() {
  return (
    <section className="py-16 md:py-24 bg-[#F8F9FA] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left — checklist visual */}
          <div className="w-full lg:flex-1">
            <div className="relative">
              {/* Card */}
              <div className="bg-[#1A2B4C] rounded-3xl p-6 sm:p-8 border-2 border-[#C5A880]/40">
                <div className="flex items-center gap-3 mb-5 sm:mb-6">
                  <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-[#C5A880] rounded-xl flex-shrink-0">
                    <i className="ri-checkbox-multiple-line text-[#1A2B4C] text-xl sm:text-2xl"></i>
                  </div>
                  <div>
                    <div className="text-[#C5A880] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">Экспресс-чек-лист</div>
                    <div className="text-white font-bold font-['Playfair_Display']">15 критических ошибок</div>
                  </div>
                </div>
                <div className="space-y-2">
                  {errors.map((error, i) => (
                    <div key={i} className="flex items-center gap-3 bg-white/5 rounded-xl px-3 sm:px-4 py-2.5">
                      <div className="w-5 h-5 flex items-center justify-center bg-[#C5A880]/20 border border-[#C5A880]/40 rounded-md flex-shrink-0">
                        <span className="text-[#C5A880] text-xs font-bold font-['Montserrat']">{i + 1}</span>
                      </div>
                      <span className="text-white/70 text-sm font-['Montserrat']">{error}</span>
                      {i < 3 && <i className="ri-fire-line text-[#C5A880] text-sm ml-auto"></i>}
                    </div>
                  ))}
                </div>
                <div className="mt-5 pt-4 border-t border-[#C5A880]/20 text-center">
                  <span className="text-white/40 text-xs font-['Montserrat']">+ ещё 5 пунктов в чек-листе...</span>
                </div>
              </div>
              {/* Floating badge */}
              <div className="absolute -top-4 -right-4 bg-[#C5A880] text-[#1A2B4C] text-xs font-bold font-['Montserrat'] px-3 py-1.5 rounded-full whitespace-nowrap">
                Бесплатно
              </div>
            </div>
          </div>

          {/* Right — text */}
          <div className="w-full lg:flex-1 text-center lg:text-left">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-5 md:mb-6 font-['Playfair_Display'] leading-tight">
              Хотите проверить сайт<br />
              <span className="text-[#C5A880]">самостоятельно?</span>
            </h2>
            <div className="w-16 h-1 bg-[#C5A880] rounded-full mb-5 md:mb-6 mx-auto lg:mx-0"></div>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed font-['Montserrat'] mb-4 text-justify">
              Скачайте Экспресс-Чек-Лист{' '}
              <strong className="text-[#1A2B4C]">«15 критических ошибок, которые сжигают ваш бюджет»</strong>.
            </p>
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed font-['Montserrat'] mb-6 sm:mb-8 text-justify">
              Это сокращённая версия методики, которая поможет вам увидеть неочевидные проблемы за <strong>5 минут</strong>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="#final-cta"
                className="group bg-[#1A2B4C] hover:bg-[#2A3B5C] text-[#C5A880] border-2 border-[#C5A880]/40 hover:border-[#C5A880] px-7 sm:px-8 py-4 rounded-full font-bold font-['Montserrat'] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer text-center text-sm sm:text-base"
              >
                <i className="ri-download-line mr-2"></i>
                Скачать чек-лист бесплатно
              </a>
            </div>
            <p className="text-gray-500 text-xs font-['Montserrat'] mt-4">
              Чек-лист придёт на ваш email вместе с подтверждением заявки
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
